export default {
  easypaisa__enter_number: 'اپنا ایزی پیسہ نمبر درج کریں',
  easypaisa__enter_number_jazzcash: 'اپنا جاز کیش نمبر درج کریں',
  easypaisa__placeholder: 'مثلاً 03XXXXXXXXX',
  easypaisa__hint: '11 ہندسے، 03 سے شروع ہوتا ہے',
  easypaisa__validation_error: 'درست ایزی پیسہ والٹ نمبر درج کریں\n(11 ہندسے، 03 سے شروع ہوتا ہے)',
  easypaisa__session_timed_out: 'سیشن ختم ہو گیا',
  easypaisa__close: 'بند کریں',
  easypaisa__confirm: 'تصدیق کریں',
  easypaisa__try_again: 'دوبارہ کوشش کریں',

  easypaisa_status__processing: 'لین دین پر کارروائی ہو رہی ہے',
  easypaisa_status__processing_label: 'پروسیسنگ...',
  easypaisa_status__success_title: 'ادائیگی کامیاب رہی',
  easypaisa_status__failed_title: 'ادائیگی ناکام رہی۔ دوبارہ کوشش کریں',
  easypaisa_status__payment_details: 'ادائیگی کی تفصیلات',
  easypaisa_status__initiation_date: 'آغاز کی تاریخ',
  easypaisa_status__amount: 'رقم',
  easypaisa_status__return: 'ویب سائٹ پر واپس جائیں',
};
